import { useRef, useState } from "react";
import { Check, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { typeTag, type BudgetItemRow } from "@/lib/budget";

const norm = (s: string) => s.trim().toLocaleLowerCase("es");
export const matchItem = (items: BudgetItemRow[], text: string) => items.find((i) => norm(i.name) === norm(text));

interface Props { value: string; items: BudgetItemRow[]; selectedId: string | null; onText: (v: string) => void; onPick: (i: BudgetItemRow) => void; showTag?: boolean }

export function ConceptInput({ value, items, selectedId, onText, onPick, showTag = true }: Props) {
  const [open, setOpen] = useState(false);
  const [other, setOther] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  const q = norm(value);
  const pickOther = () => {
    setOpen(false);
    setOther(true);
    if (exact) onText("");
    setTimeout(() => ref.current?.focus(), 0);
  };
  const list = items.filter((i) => !q || norm(i.name).includes(q));
  const exact = !!matchItem(items, value);
  return (
    <div className="relative space-y-1.5">
      <Label htmlFor="tx-description" className="text-sm text-slate-700">Concepto</Label>
      <Input ref={ref} id="tx-description" value={value} maxLength={140} autoComplete="off" placeholder={other ? "Escribe el concepto nuevo" : "Busca en tu presupuesto o elige Otro"}
        onFocus={() => !other && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => { onText(e.target.value); setOpen(!other); }}
        className="h-11" data-testid="tx-description-input" />
      {other && <p className="text-xs text-slate-500" data-testid="tx-concept-other-hint">Concepto no presupuestado. <button type="button" className="font-semibold text-[#1B2A4A] underline-offset-2 hover:underline" onClick={() => { setOther(false); setOpen(true); ref.current?.focus(); }} data-testid="tx-concept-back">Ver conceptos del presupuesto</button></p>}
      {open && (
        <ul className="absolute z-50 mt-1 max-h-64 w-full overflow-y-auto rounded-lg border border-[#DDE1E8] bg-white py-1 shadow-lg" data-testid="tx-concept-suggestions">
          <li>
            <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={pickOther} data-testid="tx-concept-other"
              className="flex w-full items-center gap-2 border-b border-[#DDE1E8] px-3 py-2 text-left text-sm text-[#1B2A4A] transition-colors hover:bg-[#F4F5F7]">
              <Plus className="h-4 w-4 text-[#C9A84C]" /> Otro (no presupuestado){q && !exact ? <>: <b className="truncate">{value.trim()}</b></> : null}
            </button>
          </li>
          {list.map((i) => (
            <li key={i.id}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(i); setOpen(false); }} data-testid={`tx-concept-option-${i.id}`}
                className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm transition-colors hover:bg-[#F4F5F7]">
                <span className="min-w-0"><b className="block truncate text-[#1B2A4A]">{i.name}</b><span className="text-xs text-slate-500">{i.category_name}</span></span>
                {selectedId === i.id ? <Check className="h-4 w-4 text-[#1B6E4F]" /> : showTag ? <span className="text-xs font-semibold text-slate-400">{typeTag(i.group)}</span> : null}
              </button>
            </li>
          ))}
          {!list.length && q && <li className="px-3 py-2 text-xs text-slate-500">Ningún concepto del presupuesto coincide.</li>}
        </ul>
      )}
    </div>
  );
}
